import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Paper,
    IconButton
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

const FactoryItemDetailsDialog = ({ open, onClose, factoryItemDetails }) => {
    const [fullWidth, setFullWidth] = React.useState(true);
    const [maxWidth, setMaxWidth] = React.useState('sm');
    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="factory-item-details"
            fullWidth={fullWidth}
            maxWidth={maxWidth}
        >
            <DialogTitle id="factory-item-details">
                Factory Item Details
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    style={{ position: 'absolute', right: 8, top: 8 }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <TableContainer component={Paper}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Category Name</TableCell>
                                <TableCell align="right">Amount (RS)</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {factoryItemDetails.map((item, index) => (
                                <TableRow key={index}>
                                    <TableCell>{item.itemName}</TableCell>
                                    <TableCell align="right">{item.amount}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
        </Dialog>
    );
};

export default FactoryItemDetailsDialog;